import React, { useEffect, useState } from 'react';
import {
  CFormTextarea, CCard, CCardBody, CButton, CModal, CModalHeader,
  CModalTitle, CModalBody, CModalFooter, CRow, CCol, CFormLabel, CFormInput, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem,
  CSpinner
} from '@coreui/react';
import AddMedicationForm from './AddMedicationForm';
import Carder from '../../components/shared/Carder';
import PatientMedications from '../../services/general/patientMedicationData.api';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import Highlighter from 'react-highlight-words';
import PatientPastNote from './PatientPastNote';
import PatientReportCRUD from '../../services/general/patientReportCrud.api';
import { Trash } from 'lucide-react';
import { useIndexedDB } from '../../context/IndexedContext';
import fetchPatientData from '../../services/general/patientGeneralAPI.api';
import CloudinaryUploaderLocally from '../../components/shared/CloudinaryUploaderLocal';
const ProviderObjectivedatatest = ({ patientID, saveTreatsShell, noteStructureRef, masterMedications, fetchMedications, appoinmentDate, noteID,
  loading, setLoading, setDataId, addDiagnosisIdsToNote, setAllLabs, allLabs, diagnosis, updatePatientDiagnosis, showComment, vitalsList, setVitalsList,
  imagingList, render, setRender, imagingTypeList, setImagingList, showAllNotes = false, viewPatientDetail, patientTreatments,
  GetPatientImagings, setShowComment, patientDBData, setPatientDBData, loggedUserProvider
}) => {
          // const { getTestOfflineData, saveTestOfflineData } = useIndexedDB()

  const {
    getTestOfflineData,
    saveTestOfflineData,
    getProviderDetails,
  } = useIndexedDB()

  const [modalVisible, setModalVisible] = useState(false);
  const [currentDate, setCurrentDate] = useState('');
  const [newMedications, setNewMedications] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [editMedicationBundleListDateId, setEditMedicationBundleListDateId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editableVitalId, setEditableVitalId] = useState("")
  const [allImaging, setAllImaging] = useState([])
  const [medicationList, setMedicationList] = useState([])

  useEffect(() => {
    const fetchOfflineData = async () => {

      let formattedData
      if (patientDBData) {
        setAllImaging(patientDBData?.allImaging || [])
        // setMedicationList(patientDBData?.allMedications || [])


        formattedData = patientDBData?.allMedications
        if (formattedData) {
          const masterMedsNames = masterMedications.map((med) => med.Data?.name?.toLowerCase())
          formattedData = formattedData.map((item) => {
            console.log(item, 'item in medis prov objective', masterMedsNames, item)
            // let parsedData = []
            // try {
            //   parsedData = item.data ? JSON.parse(item.data) : []
            // } catch (e) {
            //   console.error('Error parsing item.data:', e, item.data)
            // }

            const updatedData = Array.isArray(item?.data)
              ? item?.data?.map((med) => ({
                ...med,
                inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
              }))
              : []
            updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

            return {
              ...item,
              data: updatedData,
            }
          })
        }
        console.log(patientDBData?.allMedicationsData, 'data?.[loggedUserProvider?.ID]?.[patientID]')
        setMedicationList(formattedData || [])
      }
    }
    fetchOfflineData()
  }, [loggedUserProvider,masterMedications])

  useEffect(() => {
    setCurrentDate(getFormattedDate());
    fetchMedications();
  }, [patientID]);

  const getFormattedDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    const hh = String(today.getHours()).padStart(2, '0');
    const min = String(today.getMinutes()).padStart(2, '0');
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`;
  };

  const addMedicationToList = (medication) => {
    const { iseditingList, intervations } = medication
    console.log("medication data , ", medication)
    setNewMedications((prevList) => [...prevList, { ...medication, iseditingList: undefined, }]);
  };

  const handleSaveMedications = async () => {
    if (newMedications.length === 0) {
      toast.error('Please add some medications', toastConfig)
      return
    }
    setIsLoading(true)
    try {
      console.log("medication ", newMedications, editMedicationBundleListDateId)
      if (editMedicationBundleListDateId) {
        const formattedData = newMedications.map((item) => {
          return {
            id: item.id,
            name: item.name,
            route: item.route,
            dosage: item.dosage,
            frequency: item.frequency,
            Diagnosis: item?.Diagnosis || [],
          }
        })

        await PatientMedications("UPDATE", patientID.toString(), JSON.stringify(formattedData), "", editMedicationBundleListDateId.toString());

        setModalVisible(false);

        setEditMedicationBundleListDateId(null)

        fetchMedications()

        setNewMedications([]);

        toast.success('Successfully Updated', toastConfig)

      } else {


        const formattedData = newMedications.map((item) => {
          return {
            // customId: item.id,
            id: item.id,
            name: item.name,
            route: item.route,
            dosage: item.dosage,
            frequency: item.frequency,
            Diagnosis: item?.Diagnosis || [],
          }
        })
        console.log("medicaitionnnnnnnnnnn", formattedData)
        await PatientMedications("INSERT", patientID.toString(), JSON.stringify(formattedData), getFormattedDate());

        const allMedics = await fetchMedications()

        if (allMedics.length > 0) {
          setNoteMedicationEditId(allMedics[0]?.id)

          noteStructureRef.current = {
            ...noteStructureRef.current,
            metadata: {
              ...noteStructureRef.current.metadata,
              medId: allMedics[0]?.id || ""
            }
          }
          await saveTreatsShell(false)
        }

        setModalVisible(false);

        setNewMedications([]);

        toast.success('Successfully Updated', toastConfig)
        await fetchMedications()

      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  };

  const [noteMedicationEditId, setNoteMedicationEditId] = useState("")



  useEffect(() => {
    const medId = noteStructureRef.current?.metadata?.medId || ""
    console.log(noteStructureRef.current?.metadata?.medId, 'noteStructureRef.current?.metadata?.medId')
    setNoteMedicationEditId(medId)
  }, [])

  // useEffect(() => {
  // }, [noteMedicationEditId])

  console.log(medicationList, 'medicationList')



  const vitalFields = [
    { name: 'BloodPressure', label: 'Blood Pressure', unit: 'mmHg' },
    { name: 'HeartRate', label: 'Heart Rate', unit: 'bpm' },
    { name: 'RespiratoryRate', label: 'Respiratory Rate', unit: 'rpm' },
    { name: 'Temperature', label: 'Temperature', unit: '°F' },
    { name: 'SpO2', label: 'SpO2', unit: '%' },
    { name: 'InhaledO2', label: 'Inhaled O2', unit: '%' },
    { name: 'HeartCirc', label: 'Heart Circ', unit: 'in' },
    { name: 'Height', label: 'Height', unit: 'ft/in' },
    { name: 'Weight', label: 'Weight', unit: 'lbs/oz' },

  ];


  useEffect(() => {
    const vitalEditId = noteStructureRef?.current?.metadata?.vitalId
    if (vitalEditId) {
      setEditableVitalId(vitalEditId)
    }
  }, [])


  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous'];
  const [visible, setVisible] = useState(false);
  const [modeReport, setModeReport] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  const [viewer, setViewer] = useState(false);
  const [selectedFileViewBase64, setSelectedFileViewBase64] = useState('');
  const [reportData, setReportData] = useState({
    Labs: [],
    Medication: [],
    Imaging: [],
    Miscellaneous: [],
  });
  const [file, setFile] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFileBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const toggleModal = (mode) => {
    // if (visible) {
    //   setVisible(false);
    //   setModeReport('');
    //   setFileBase64('');
    // } else {
    //   setVisible(true);
    //   setModeReport(mode);
    // }
    setModeReport(mode);
  };
  console.log(modeReport,'modereport')

  // const getFormattedDate = () => {
  //     const today = new Date();
  //     const dd = String(today.getDate()).padStart(2, '0');
  //     const mm = String(today.getMonth() + 1).padStart(2, '0');
  //     const yyyy = today.getFullYear();
  //     const hh = String(today.getHours()).padStart(2, '0');
  //     const min = String(today.getMinutes()).padStart(2, '0');
  //     return `${mm}.${dd}.${yyyy} ${hh}:${min}`;
  // };

  const fetchReports = async () => {
    setIsPageLoading(true);
    const data = await getTestOfflineData()
    if (data) {
      console.log(data?.[loggedUserProvider?.ID]?.[patientID]?.reportData, 'reports comming')
      // let formattedData;
      //                       formattedData = await PatientReportCRUD(
      //                         'GET',
      //                         patient?.PatientID?.toString(),
      //                         '',
      //                         sections.toString()
      //                       );

      //                       if (formattedData) {
      //                         formattedData = JSON.parse(formattedData.d)?.Data;
      //                         formattedData = formattedData.map((item) => {
      //                           return {
      //                             ...item,
      //                             data: JSON.parse(item.data),
      //                           };
      //                         });
      //                       }
      for (const sections of threeSections) {
        setReportData((p) => ({
          ...p,
          [sections]: data?.[loggedUserProvider?.ID]?.[patientID]?.reportData?.[sections]?.filter(item=>!item.isToBeDeleted) || [],
        }));
      }
    }

    setIsPageLoading(false);
  };

  useEffect(() => {
    fetchReports();
  }, []);

  console.log(reportData, 'reportData');
  const handleSubmit = async (mediaData) => {
    const jsonFormat = JSON.stringify(mediaData);

    await PatientReportCRUD(
      'INSERT',
      patientID.toString(),
      '',
      modeReport.toString(),
      jsonFormat,
      getFormattedDate().toString()
    );
    setModeReport('');
    setFileBase64('');
    // setFile([]);
    setVisible(false);
    await fetchReports();
  };

const handleDeleteOfflineData = async (id) => {
  const offlineData = await getTestOfflineData();
  console.log(offlineData, 'offlineData before deleting files');

  const userData = offlineData[loggedUserProvider?.ID] || {};
  const patientData = userData[patientID] || {};
  const reportData = patientData.reportData || {};
  const modeData = reportData[modeReport] || [];

  const findItem = modeData.find((item) => item.id === id);
  console.log(findItem,modeData,modeReport, 'findItem',id);

  if (!findItem) {
    console.warn('No item found with this ID');
    return;
  }

  if (findItem.isToUpload) {
    reportData[modeReport] = modeData.filter((item) => item.id !== id);
    await saveTestOfflineData(offlineData);
    await fetchReports();
  } else {
    reportData[modeReport] = modeData.map((item) =>
      item.id === id ? { ...item, isToBeDeleted: true } : item
    );

    await saveTestOfflineData(offlineData);
    await fetchReports();
  }

  console.log(offlineData, 'offlineData after deleting files');
};

  const handleDeleteFileData = async (id) => {
    // await PatientReportCRUD(
    //   'DELETE',
    //   patientID.toString(),
    //   id
    // );
    
    await handleDeleteOfflineData(id)
    await fetchReports();
  }
  const handleViewFile = (file) => {
    setSelectedFileViewBase64(file);
    setViewer(true);
  };

  const handleDeleteFile = (id) => {

    setFile(prevFiles => {
      if (prevFiles.length === 1) return [];
      return prevFiles.filter((item, i) => item.id !== id);
    });

  };


  console.log(reportData,"reportData")

  const handleAddFilesToNewlyAddedOffline = async (uploadedFiles) => {
    const structure = uploadedFiles.map((item, idx) => {
      return {
        data: [item],
        date: new Date().getTime().toString(),
        id: new Date().getTime(),
        type: modeReport,
        isToUpload: true,
        patientID: patientID
      }
    })
    let offlineData = await getTestOfflineData()
    console.log(structure,offlineData,'offlineData before adding files')
    offlineData = offlineData || {};
    offlineData[loggedUserProvider?.ID] = offlineData[loggedUserProvider?.ID] || {};
    offlineData[loggedUserProvider?.ID][patientID] = offlineData[loggedUserProvider?.ID][patientID] || {};
    offlineData[loggedUserProvider?.ID][patientID].reportData = offlineData[loggedUserProvider?.ID][patientID].reportData || {};
    offlineData[loggedUserProvider?.ID][patientID].reportData[modeReport] = offlineData[loggedUserProvider?.ID][patientID].reportData[modeReport] || [];
    offlineData[loggedUserProvider?.ID][patientID].reportData[modeReport] = offlineData[loggedUserProvider?.ID][patientID].reportData[modeReport].concat(structure);
    await saveTestOfflineData(offlineData) 
    console.log(structure,offlineData,'offlineData after adding files')
  }
  const handleCloudinaryUpload = async (uploadedFiles) => {
    console.log(uploadedFiles, 'uploadedFiles')
    await handleAddFilesToNewlyAddedOffline(uploadedFiles)
    await fetchReports();
    // setFile(prevFiles => {
    //   const isDuplicate = prevFiles.some(file => file.url === url);
    //   if (isDuplicate) return prevFiles;
    //   handleSubmit([{ url, type, fileName, id, publicId }]);
    //   return [...prevFiles, { url, type, fileName, id, publicId }];
    // });
    // setTimeout(()=>(handleSubmit,2000))

  };

  return (
    <div className="d-flex flex-column " style={{ gap: '4rem' }}>
      <CAccordion alwaysOpen style={{ gap: '10px' }} className="d-flex flex-column">
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>Vitals</CAccordionHeader>
          <CAccordionBody>
            <div>
              {vitalsList.map((vital, index) => (
                <div
                  className=""
                  key={index}
                  style={{
                    overflow: 'hidden',
                    borderRadius: '1rem',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
                    backgroundColor: '#191919',
                    color: 'white',
                  }}
                >
                  <CRow className="p-4">
                    <CCol md="6">
                      {vitalFields.slice(0, Math.ceil(vitalFields.length / 2)).map(
                        (field, idx) =>
                          vital[field.name] && (
                            <div key={idx} className="mb-2">
                              <strong>{field.label}:</strong> {vital[field.name]} {field.unit}
                            </div>
                          ),
                      )}
                    </CCol>
                    <CCol md="6">
                      {vitalFields.slice(Math.ceil(vitalFields.length / 2)).map(
                        (field, idx) =>
                          vital[field.name] && (
                            <div key={idx} className="mb-2">
                              <strong>{field.label}:</strong> {vital[field.name]} {field.unit}
                            </div>
                          ),
                      )}
                    </CCol>
                    {vital.Remarks && (
                      <div className="mb-2" style={{ whiteSpace: 'pre-line' }}>
                        <strong>Remarks:</strong> {vital.Remarks}
                      </div>
                    )}
                  </CRow>
                </div>
              ))}
              {vitalsList.length === 0 && (
                <div className="text-left " style={{ color: 'gray', fontSize: '14px' }}>
                  No vitals Available
                </div>
              )}
            </div>
          </CAccordionBody>
        </CAccordionItem>
        <CAccordionItem itemKey={2}>
          <CAccordionHeader>Labs</CAccordionHeader>
          <CAccordionBody>
            <div>
              {allLabs &&
                allLabs.map((labEntry, index) => {
                  return (
                    <div
                      key={index}
                      // deleteFunc={labEntry.id === noteEditedLabId ? () => { setDeleteVisibleId(labEntry.id) } : null}
                      // editFunc={
                      //     labEntry.id === noteEditedLabId
                      //         ?
                      //         () => handleEditLabs(labEntry)
                      //         : null}

                      className=" "
                      title={`Date: ${new Date(labEntry.date).toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      })}`}
                      style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#191919', overflow: 'auto' }}
                    >
                      <div className="p-3 " style={{ width: '120%' }}>
                        <p>
                          Date:{' '}
                          {new Date(labEntry.date).toLocaleDateString('en-US', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                          })}
                        </p>
                        <CTable className="table" style={{ tableLayout: 'fixed' }} responsive>
                          <CTableHead>
                            <CTableRow>
                              <CTableHeaderCell style={{ width: '90px', color: 'white' }}>Lab Name</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '70px', color: 'white' }}>Value</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '70px', color: 'white' }}>Unit</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '60px', color: 'white' }}>Range</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '100px', color: 'white' }}>Diagnosis</CTableHeaderCell>
                              <CTableHeaderCell style={{ width: '200px', color: 'white' }}>Remark</CTableHeaderCell>
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {labEntry.data?.map((lab, labIndex) => {
                              const value = lab.value ? parseFloat(lab.value) : null
                              const rangeParts = lab.range ? lab.range.split('-').map((part) => parseFloat(part.trim())) : []
                              const isValueInRange = value !== null && rangeParts.length === 2 && value >= rangeParts[0] && value <= rangeParts[1]
                              return (
                                <CTableRow key={labIndex}>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.name}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.value || '-'}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.unit}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.range}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.diagnosis}</CTableDataCell>
                                  <CTableDataCell style={{ color: isValueInRange ? 'white' : 'orange' }}>{lab.remark}</CTableDataCell>
                                </CTableRow>
                              )
                            })}
                          </CTableBody>
                        </CTable>
                      </div>
                    </div>
                  )
                })}

              {allLabs.length === 0 && (
                <div className="text-left  " style={{ color: 'gray', fontSize: '14px' }}>
                  No Labs Available
                </div>
              )}
            </div>
          </CAccordionBody>
        </CAccordionItem>
        <CAccordionItem itemKey={3}>
          <CAccordionHeader>Imaging</CAccordionHeader>
          <CAccordionBody>
            <div>
              <div>
                <div className="" style={{ borderRadius: '10px' }}>
                  {/* <hr className="hr-text" data-content="Current Imagings" /> */}
                  <h6 className="text-white d-flex justify-content-center  ">Current Imagings</h6>

                  {allImaging
                    .filter((imgEntry) => noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
                    ?.reverse()
                    .map((imgEntry, index) => {
                      return (
                        <div
                          // editFunc={
                          //     imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id))
                          //         ? () => handleEditPatientImaging(imgEntry)
                          //         : null
                          // }
                          // deleteFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => setDeleteVisibleId(imgEntry.id) : null}
                          key={index}
                          style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#191919' }}
                          className="mt-4 overflow-hidden"
                        >
                          <CCardBody>
                            <div className="mb-3">
                              Date:{' '}
                              {new Date(imgEntry.date).toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                              })}
                            </div>
                            <div>
                              <div className="mb-2">
                                <strong>Imaging Type:</strong> {imgEntry.data?.name}
                              </div>
                              <div className="mb-3">
                                <strong>Impression:</strong>

                                <Highlighter
                                  textToHighlight={imgEntry?.data?.impression || ''}
                                  searchWords={imgEntry?.data?.selectedText || []}
                                  highlightStyle={{
                                    backgroundColor: 'transparent',
                                    color: 'orange',
                                    fontWeight: 'bold',
                                  }}
                                />
                              </div>
                              {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
                            </div>

                            {/* <CTable>
                                                <CTableHead>
                                                    <CTableRow>
                                                        <CTableHeaderCell>Imaging Type</CTableHeaderCell>
                                                        <CTableHeaderCell>Impression</CTableHeaderCell>
                
                                                    </CTableRow>
                                                </CTableHead>
                                                <CTableBody>
                                                    <CTableRow>
                                                        <CTableDataCell style={{ width: "40%" }} className='' valign="">{imgEntry.data?.name}</CTableDataCell>
                                                        <CTableDataCell style={{ width: "60%" }} className='' valign="" >
                                                            <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
                                                        </CTableDataCell>
                
                
                                                    </CTableRow>
                                                </CTableBody>
                                            </CTable> */}
                          </CCardBody>
                        </div>
                      )
                    })}
                </div>
                {!loading && allImaging.length === 0 && (
                  <div className="text-left  " style={{ color: 'gray', fontSize: '14px' }}>
                    No Current Imaging Available
                  </div>
                )}

                <div className="mt-4">
                  <h6 className="text-white d-flex justify-content-center  ">Old Imagings</h6>

                  {allImaging
                    ?.filter((imgEntry) => !noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
                    ?.reverse()
                    .map((imgEntry, index) => {
                      return (
                        <div
                          // editFunc={
                          //     imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id))
                          //         ? () => handleEditPatientImaging(imgEntry)
                          //         : null
                          // }
                          // deleteFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => setDeleteVisibleId(imgEntry.id) : null}
                          key={index}
                          style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#191919' }}
                          className="mt-3 overflow-hidden"
                        >
                          <CCardBody>
                            <div className="mb-3">
                              Date:{' '}
                              {new Date(imgEntry.date).toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                              })}
                            </div>
                            <div>
                              <div className="mb-2">
                                <strong>Imaging Type:</strong> {imgEntry.data?.name}
                              </div>
                              <div className="mb-3">
                                <strong>Impression:</strong>
                                <div className="p-2">
                                  <Highlighter
                                    textToHighlight={imgEntry?.data?.impression || ''}
                                    searchWords={imgEntry?.data?.selectedText || []}
                                    highlightStyle={{
                                      backgroundColor: 'transparent',
                                      color: 'orange',
                                      fontWeight: 'bold',
                                    }}
                                  />
                                </div>
                              </div>
                              {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
                            </div>

                            {/* <CTable>
                                                <CTableHead>
                                                    <CTableRow>
                                                        <CTableHeaderCell>Imaging Type</CTableHeaderCell>
                                                        <CTableHeaderCell>Impression</CTableHeaderCell>
                
                                                    </CTableRow>
                                                </CTableHead>
                                                <CTableBody>
                                                    <CTableRow>
                                                        <CTableDataCell style={{ width: "40%" }} className='' valign="">{imgEntry.data?.name}</CTableDataCell>
                                                        <CTableDataCell style={{ width: "60%" }} className='' valign="" >
                                                            <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
                                                        </CTableDataCell>
                
                
                                                    </CTableRow>
                                                </CTableBody>
                                            </CTable> */}
                          </CCardBody>
                        </div>
                      )
                    })}
                </div>
                {!loading && allImaging?.filter((imgEntry) => !noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))?.length === 0 && (
                  <div className="text-left " style={{ color: 'gray', fontSize: '14px' }}>
                    No Old Imaging Available
                  </div>
                )}
              </div>
            </div>
          </CAccordionBody>
        </CAccordionItem>
        <CAccordionItem itemKey={4}>
          <CAccordionHeader>Medications</CAccordionHeader>
          <CAccordionBody>
            <div>
              <h6 className="text-white d-flex justify-content-center  ">Current Medications</h6>
              {medicationList.length > 0 &&
                medicationList
                  .filter((med) => noteStructureRef?.current?.metadata?.medId === med.id)
                  .map((medEntry, index) => {
                    return (
                      // <Carder
                      //     // deleteFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { setDeleteVisibleId(medEntry.id) } : null}
                      //     // editFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { editMedicationPatient(medEntry) } : null}
                      //     className={'mt-4'}
                      //     title={`Date:
                      //     ${new Date(medEntry.date).toLocaleDateString('en-US', {
                      //         month: '2-digit',
                      //         day: '2-digit',
                      //         year: 'numeric'
                      //     })}
                      //     `} key={index} style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} >
                      //     <div className='p-4'>
                      //         <p>Date : {new Date(medEntry.date).toLocaleDateString('en-US', {
                      //             month: '2-digit',
                      //             day: '2-digit',
                      //             year: 'numeric'
                      //         })}</p>
                      //         <CTable className=''>
                      //             <CTableHead>
                      //                 <CTableRow>
                      //                     <CTableHeaderCell>Medication Names</CTableHeaderCell>
                      //                     <CTableHeaderCell>Dosage</CTableHeaderCell>
                      //                     <CTableHeaderCell>Route</CTableHeaderCell>
                      //                     <CTableHeaderCell>Frequency</CTableHeaderCell>
                      //                 </CTableRow>
                      //             </CTableHead>
                      //             <CTableBody className='p-0'>
                      //                 {medEntry?.data.map((med, medIndex) => {
                      //                     return(
                      //                         <CTableRow

                      //                         key={medIndex}>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.name}</CTableDataCell>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.dosage}</CTableDataCell>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.route}</CTableDataCell>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.frequency}</CTableDataCell>
                      //                     </CTableRow>
                      //                     )
                      //                 })}
                      //             </CTableBody>
                      //         </CTable>
                      //     </div>
                      // </Carder>
                      <div
                        className="mt-4"
                        style={{
                          borderRadius: '1rem',
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
                          backgroundColor: '#191919',
                          color: 'white',
                        }}
                        key={index}
                      >
                        <div className="p-4">
                          <p>
                            Date :{' '}
                            {new Date(medEntry.date).toLocaleDateString('en-US', {
                              month: '2-digit',
                              day: '2-digit',
                              year: 'numeric',
                            })}
                          </p>
                          <CTable
                            className=" "
                            style={{
                              borderCollapse: 'collapse',
                              width: '100%',
                              background: '#191919',
                            }}
                          >
                            <CTableHead>
                              <CTableRow>
                                <CTableHeaderCell style={{ color: 'white' }}>Medication Names</CTableHeaderCell>
                                <CTableHeaderCell style={{ color: 'white' }}>Dosage</CTableHeaderCell>
                                <CTableHeaderCell style={{ color: 'white' }}>Route</CTableHeaderCell>
                                <CTableHeaderCell style={{ color: 'white' }}>Frequency</CTableHeaderCell>
                              </CTableRow>
                            </CTableHead>
                            <CTableBody className="p-0 ">
                              {medEntry?.data?.map((med, medIndex) => {
                                return (
                                  <CTableRow key={medIndex}>
                                    <CTableDataCell
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.name}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.dosage}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.route}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.frequency}
                                    </CTableDataCell>
                                  </CTableRow>
                                )
                              })}
                            </CTableBody>
                          </CTable>
                        </div>
                      </div>
                    )
                  })}

              {medicationList.filter((med) => noteStructureRef?.current?.metadata?.medId === med.id)?.length === 0 && (
                <div className="text-left  " style={{ color: 'gray', fontSize: '14px' }}>
                  No Current Medications Available
                </div>
              )}
            </div>

            <div>
              <div className=" " />
              <div className=" mt-3">
                <h6 className="text-white d-flex justify-content-center  ">Old Medications</h6>

                {medicationList.length > 0 &&
                  medicationList
                    .filter((med) => noteStructureRef?.current?.metadata?.medId !== med.id)
                    .map((medEntry, index) => {
                      return (
                        <div
                          className="mt-4"
                          key={index}
                          style={{
                            borderRadius: '1rem',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
                            backgroundColor: '#191919',
                            color: 'white',
                          }}
                        >
                          <div className="p-4">
                            <p>
                              Date :{' '}
                              {new Date(medEntry.date).toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                              })}
                            </p>
                            <CTable
                              className=" "
                              style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                backgroundColor: '#191919',
                              }}
                            >
                              <CTableHead>
                                <CTableRow
                                  style={{
                                    backgroundColor: '#2a2a2a',
                                  }}
                                >
                                  <CTableHeaderCell style={{ color: 'white' }}>Medication Names</CTableHeaderCell>
                                  <CTableHeaderCell style={{ color: 'white' }}>Dosage</CTableHeaderCell>
                                  <CTableHeaderCell style={{ color: 'white' }}>Route</CTableHeaderCell>
                                  <CTableHeaderCell style={{ color: 'white' }}>Frequency</CTableHeaderCell>
                                </CTableRow>
                              </CTableHead>
                              <CTableBody className="p-0">
                                {medEntry?.data?.map((med, medIndex) => {
                                  return (
                                    <CTableRow key={medIndex}>
                                      <CTableDataCell
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.name}
                                      </CTableDataCell>
                                      <CTableDataCell
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.dosage}
                                      </CTableDataCell>
                                      <CTableDataCell
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.route}
                                      </CTableDataCell>
                                      <CTableDataCell
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.frequency}
                                      </CTableDataCell>
                                    </CTableRow>
                                  )
                                })}
                              </CTableBody>
                            </CTable>
                          </div>
                        </div>
                      )
                    })}

                {medicationList.filter((med) => noteStructureRef?.current?.metadata?.medId !== med?.id)?.length === 0 && (
                  <div className="text-left  " style={{ color: 'gray', fontSize: '14px' }}>
                    No Old Medications Available
                  </div>
                )}
              </div>
            </div>
          </CAccordionBody>
        </CAccordionItem>
        <CAccordionItem itemKey={6}>
          <CAccordionHeader>Previous Notes</CAccordionHeader>
          <CAccordionBody>
            {showAllNotes && (
              <div className="w-full">
                <div className="previous-notes">
                  <PatientPastNote viewPatientDetail={viewPatientDetail} patientTreatments={patientTreatments} noteID={noteID} providerCall={true} />
                </div>
              </div>
            )}
          </CAccordionBody>
        </CAccordionItem>
        <CAccordionItem itemKey={5}>
          <CAccordionHeader>Reports</CAccordionHeader>
          <CAccordionBody>
            <div className="d-flex align-items-start gap-4 flex-column">
              {Object.entries(reportData).map(([key, data], i) => {
                return (
                  <div className="pb-12" key={i}>
                    <h6 className={`${role === 'provider' ? 'text-white' : ''} p-0 m-0 `}>{key}</h6>
                    <div className="d-flex  flex-wrap gap-3 mt-3">
                      {isPageLoading ? (
                        <CSpinner className="mt-3" />
                      ) : (
                        <div className="d-flex align-items-center flex-wrap gap-2  ">
                          {data?.map((entry, idx) => (
                            <div key={idx} className="mb-4">
                              <div className="d-flex flex-wrap gap-3">{entry.data?.map((file, fileIdx) => {
  const fileUrl = file.url
    ? file.url // already uploaded
    : file.file
    ? URL.createObjectURL(file.file) // local new file
    : '';

  const fileType = file.type || (file.file ? file.file.type.split('/')[0] : '');
  const extension = fileUrl?.split('.').pop()?.toLowerCase() || '';

  return (
    <div key={fileIdx} className="d-flex flex-column align-items-center text-left">
      {fileType === 'image' ? (
        <div
          style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            borderRadius: '4px',
            overflow: 'hidden',
          }}
          className="shadow border"
        >
          <img
            src={fileUrl}
            alt={file.fileName || 'Preview'}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />

          <div
            style={{
              position: 'absolute',
              top: '4px',
              right: '4px',
              display: 'flex',
              gap: '6px',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              borderRadius: '4px',
              padding: '2px',
            }}
          >
            <Trash
              className="cursor-pointer text-danger"
              size={15}
              onClick={() => {
                console.log(key,'key')
                toggleModal(key)
                handleDeleteFileData(entry.id)
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      ) : fileType === 'video' || ['mp4', 'webm', 'ogg'].includes(extension) ? (
        <div
          style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            borderRadius: '4px',
            overflow: 'hidden',
          }}
          className="shadow border"
        >
          <video
            src={fileUrl}
            controls
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />

          <div
            style={{
              position: 'absolute',
              top: '4px',
              right: '4px',
              display: 'flex',
              gap: '6px',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              borderRadius: '4px',
              padding: '2px',
            }}
          >
            <Trash
              className="cursor-pointer text-danger"
              size={15}
              onClick={() => {
                console.log(key,'key')
                toggleModal(key)
                handleDeleteFileData(entry.id)}}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      ) : ['pdf', 'doc', 'docx'].includes(extension) ? (
        <div
          style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            borderRadius: '4px',
            overflow: 'hidden',
            background: '#f8f9fa',
          }}
          className="d-flex align-items-center justify-content-center border shadow"
        >
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: '100%',
              height: '100%',
              textDecoration: 'none',
              color: 'inherit',
            }}
            className="d-flex align-items-center justify-content-center flex-column"
          >
            <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
            <p className="small m-0">{extension.toUpperCase()}</p>
          </a>

          <div
            style={{
              position: 'absolute',
              top: '4px',
              right: '4px',
              display: 'flex',
              gap: '6px',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              borderRadius: '4px',
              padding: '2px',
            }}
          >
            <Trash
              className="cursor-pointer text-danger"
              size={15}
              onClick={() => {
                console.log(key,'key')
                toggleModal(key)
                handleDeleteFileData(entry.id)
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      ) : (
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '4px',
            background: '#e0e0e0',
          }}
          className="d-flex align-items-center justify-content-center border"
        >
          <div>
            <i className="bi bi-file-earmark" style={{ fontSize: '24px' }}></i>
            <p className="small m-0">File</p>
          </div>
        </a>
      )}
      <small className="mt-1 text-truncate" style={{ maxWidth: '100px' }}>
        {file.fileName}
      </small>
    </div>
  );
})}

                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Upload Button */}
                      <div
                        onClick={() => toggleModal(key)}
                        className="shadow d-flex align-items-center justify-content-center cursor-pointer "
                        style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '12px',
                          backgroundColor: role === 'provider' ? '#191919' : 'white',
                        }}
                      >
                        {console.log('data data ', data)}
                        <CloudinaryUploaderLocally
                          // filesAl={data || [] }
                          onDelete={handleDeleteFile}
                          onUploadSuccess={handleCloudinaryUpload}
                          showStyleButton={true}
                        />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            <CModal
              size="md"
              backdrop={'static'}
              visible={visible}
              onClose={() => {
                setVisible(false)
                setModeReport('')
                setFileBase64('')
              }}
            >
              <CModalHeader>
                <CModalTitle>Upload and Preview File</CModalTitle>
              </CModalHeader>
              <CModalBody>
                {/* <div className='mb-3'>
                                <CFormLabel
                                  className='w-full gap-2 d-flex align-items-center justify-content-center flex-column bg-light rounded'
                                  style={{ height: '200px', background: 'rgb(233 236 252)' }}
                                  htmlFor='formFile'
                                >
                                  <Upload size={20} />
                                  <p className='font-weight-bold'>Choose Image or PDF</p>
                                  <p
                                    style={{ fontSize: '14px' }}
                                    className='font-weight-bold p-0 m-0'
                                  >
                                    We accept JPG, PNG, & PDF formats
                                  </p>
                                </CFormLabel>
                                <CFormInput
                                  accept='image/*,application/pdf'
                                  type='file'
                                  id='formFile'
                                  className='hidden'
                                  onChange={handleFileUpload}
                                  label='Default file input example'
                                />
                              </div>
                              {fileBase64 && (
                                <div
                                  className='mt-3 shadow rounded'
                                  style={{
                                    width: '80px',
                                    height: '80px',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {fileBase64.startsWith('data:image') ? (
                                    <img
                                      src={fileBase64}
                                      alt='Uploaded'
                                      className='object-fit-cover w-100 h-100'
                                    />
                                  ) : (
                                    <div className='d-flex align-items-center justify-content-center h-100'>
                                      <FileText/>
                                    </div>
                                  )}
                                </div>
                              )} */}

                <CloudinaryUploaderLocally
                  // filesAl={editEducations ? editEducations?.file : file}
                  onDelete={handleDeleteFile}
                  onUploadSuccess={handleCloudinaryUpload}
                  showStyleButton={true}
                />
              </CModalBody>
              <CModalFooter className="d-flex p-3 border-top m-0">
                <CButton
                  color="secondary"
                  onClick={() => {
                    setVisible(false)
                    setModeReport('')
                    setFileBase64('')
                  }}
                >
                  Close
                </CButton>
                <CButton onClick={handleSubmit} color="primary">
                  Save Changes
                </CButton>
              </CModalFooter>
            </CModal>

            {viewer && (
              <div
                style={{
                  height: '100vh',
                  position: 'fixed',
                  background: 'rgb(39 39 39 / 58%)',
                  top: 0,
                  left: 0,
                  zIndex: '100000000',
                }}
                className="position-fixed d-flex align-items-center justify-content-center top-0 left-0 z-50 w-100"
              >
                <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                  <X
                    onClick={() => {
                      setViewer(false)
                      setSelectedFileViewBase64('')
                    }}
                    size={30}
                    strokeWidth={1}
                    className="bg-white rounded-circle text-black"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '10px',
                    }}
                  />
                  {selectedFileViewBase64.startsWith('data:image') ? (
                    <img src={selectedFileViewBase64} className="w-full h-full object-fit-cover" alt="" />
                  ) : (
                    <iframe
                      src={selectedFileViewBase64}
                      title="PDF Preview"
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </div>
  )
}

export default ProviderObjectivedatatest
